import { Component, OnInit, forwardRef } from '@angular/core';
import { 
    IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

import { DemoozCardComponent } from '@demooz/components';
import { DataService } from '@app/services';

@Component({
    selector: 'app-contacts',
    templateUrl: './contacts.component.html',
    styleUrls: ['./contacts.component.scss'],
    imports: [
        IonIcon, TranslatePipe, forwardRef(() => DemoozCardComponent)
    ]
})
export class ContactsComponent  implements OnInit {
          
    communications: any = this.dataService.operation.communications;
    isContactAvailable: boolean = false;
      
    constructor(         
        public dataService: DataService
    ) { }

    ngOnInit() {
        this.isContactAvailable = (this.communications?.call?.isEnabled && this.communications?.call?.recipient && this.communications?.call?.recipient !== '')
            || (this.communications?.sms?.isEnabled && this.communications?.sms?.recipient && this.communications?.sms?.recipient !== '')
            || (this.communications?.email?.isEnabled && this.communications?.email?.recipient && this.communications?.email?.recipient !== '');
    }
    
    contactByPhone(){
        if(this.communications.call.recipient && this.communications.call.recipient !== ''){
            let link = document.createElement('a');
            link.href = 'tel:'+this.communications.call.recipient;
            link.click();
        }
    }
    
    contactBySms(){
        if(this.communications.sms.recipient && this.communications.sms.recipient !== ''){
            let link = document.createElement('a');
            link.href = 'sms:'+this.communications.sms.recipient;
            link.click();
        }
    }
    
    contactByMail(){
        if(this.communications.email.recipient && this.communications.email.recipient !== ''){
            let link = document.createElement('a');
            link.href = 'mailto:'+this.communications.email.recipient;
            link.click();
        }
    }
    
}
